import { queryLiveDataByCustompage } from "@/api/live";
import { LivePlayer } from "@/components/live";
import exposure from "@/utils/expose/exposure";
import Track from "@/utils/track";
import useNavigation from "@/utils/useNavigate";
import React, { useEffect, useState } from "react";
import LiveDesc from "../live-desc";
import LiveStatus from "../live-status";
import styles from "./index.module.less";

interface Live_1_3Props {
  componentInfo?: any;
  pageData?: any;
  resourceRank?: any;
}

const Live_1_3: React.FC<Live_1_3Props> = ({ componentInfo, pageData, resourceRank }) => {
  const track = Track();
  const [liveList, setLiveList] = useState<any>([]);
  const { navigate2LiveItem } = useNavigation();

  useEffect(() => {
    if (!componentInfo) {
      return;
    }
    queryLiveDataByCustompage({ ...componentInfo }).then(res => {
      setLiveList(res || []);
    });
  }, [componentInfo]);

  useEffect(() => {
    const interval = setInterval(() => {
      let flag = false;
      for (let i = 0; i < (liveList?.length || 0); i++) {
        const dom = document.getElementById(`live-${liveList[i]?.liveNo}`);
        if (dom) {
          exposure.add({
            el: dom,
          });
        } else {
          flag = true;
        }
        if (!flag) {
          clearInterval(interval);
        }
      }
    }, 1000);
  }, [liveList]);

  const handleClick = (item: any, index: number) => {
    const { liveStatus } = item || {};
    track.track("resource_click", {
      page_name: pageData?.name,
      resource_type: "直播",
      resource_content: "直播",
      resource_rank: resourceRank,
      relativeRank: index + 1,
      domain: "CONFERENCE3",
      market_id: pageData?.pageCode,
      live_name: item?.liveTitle,
      live_type: item?.liveType,
      live_status: liveStatus === 20 ? "直播中" : liveStatus === 10 ? "直播预告" : "直播结束",
      live_no: item?.liveNo,
      btn_name: "查看直播",
    });
    navigate2LiveItem(item);
  };

  return (
    <>
      {liveList?.length > 0 ? (
        <div className={styles.card}>
          {liveList.map((item, index) => {
            return (
              <div
                id={`live-${item?.liveNo}`}
                className={styles.card__item}
                key={item?.liveNo}
                data-param={JSON.stringify({
                  page_name: pageData?.name,
                  resource_type: "直播",
                  resource_content: "直播",
                  resource_rank: resourceRank,
                  relativeRank: index + 1,
                  domain: "CONFERENCE3",
                  market_id: pageData?.pageCode,
                  live_name: item?.liveTitle,
                  live_type: item?.liveType,
                  live_status:
                    item?.liveStatus === 20
                      ? "直播中"
                      : item?.liveStatus === 10
                        ? "直播预告"
                        : "直播结束",
                  live_no: item?.liveNo,
                })}
                onClick={() => {
                  handleClick(item, index);
                }}>
                <LiveStatus liveData={item} />
                <div className={styles.item__body}>
                  {item?.liveStatus !== 20 ? (
                    <div className={styles.body__mask}>
                      <img className={styles.mask__img} src={item?.liveCover || item?.coverUrl} />
                    </div>
                  ) : (
                    <LivePlayer
                      roomId={item?.liveNo}
                      className={styles.live}
                      muted={true}
                      onError={error => {
                        console.log("播放器报错", error);
                      }}
                      poster={item?.liveCover || item?.coverUrl}
                      supportClick={false}
                      mutedVisible={false}
                      showPlayBtn={false}
                    />
                  )}
                </div>
                <div className={styles.item__footer}>
                  <div className={styles.footer__title}>{item?.liveTitle || ""}</div>
                  <div className={styles.footer__desc}>
                    <LiveDesc
                      iconName={item?.liveLabelInfo?.iconName}
                      showText={item?.liveLabelInfo?.showText}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default Live_1_3;
